// JsFromRoutes CacheKey 9ead556406cdf9e4f6c28c8219e91283
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/axios'

export default {
  pendingActions: definePathHelper('post', '/deals/:deal_id/public/pending_actions'),
  exportXlsx: definePathHelper('post', '/deals/:deal_id/public/export_xlsx'),
  export: definePathHelper('post', '/deals/:deal_id/public/export'),
  list: definePathHelper('get', '/deals/:deal_id/public'),
  create: definePathHelper('post', '/deals/:deal_id/public'),
  update: definePathHelper('patch', '/deals/:deal_id/public/:id'),
}
